import React, { useEffect, useReducer, useState } from 'react';
import _ from 'lodash';
import './RydContextLayer.css';
import { HorizontalContextItem } from '../HorizontalContext';
import {
    ContextCell,
    ContextFrame,
    ContextPlane,
    TimeCut
} from '../../model/context';
import { RydContextPlaneGrid } from './RydContextGrid';
import { RydProject } from '../../model/project';

function ContextPlaneOld({ data }) {
    const [gridColumnsWidths, setGridColumnsWidths] = React.useState(_.range(data[0].length).map(() => 24));
    const makeOutlineStr = (item) => {
        let x = item ? item.outlineColor : '#ebebeb';
        return "1px solid " + x;
    };
    const updateColumnWidth = (colIdx, isCollapsed) => {
        let newWidths = [...gridColumnsWidths];
        newWidths[colIdx] = isCollapsed ? 24 : 280;
        setGridColumnsWidths(newWidths);
    };

    return (
        <div>
            {data.map((row, rowIdx) => (
                <div key={rowIdx} style={{ display: 'flex' }} className='context--row'>
                    {row.map((item, colIdx) => (
                        <div key={colIdx}
                            className='context-grid--item'
                            style={{
                                outline: makeOutlineStr(item),
                                backgroundColor: (item ? item.outlineColor : 'white'),
                                minWidth: (gridColumnsWidths[colIdx] + 'px')
                            }}>
                            {item && item.isStart
                                ? <HorizontalContextItem
                                    data={item.data}
                                    position={colIdx}
                                    uniqueColor={item.outlineColor}
                                    columnExpandStateChangeCB={_.curry(updateColumnWidth)(colIdx)}
                                />
                                : ''}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

function RydContextLayerPlane({
    cp
}: {
    cp?: ContextPlane
}) {
    const [plane, setPlane] = useState(cp ? cp : new ContextPlane(20, 5));
    const [rowIndex, setRowIndex] = useState(0);
    const [start, setStart] = useState(0);
    const [length, setLength] = useState(1);
    const [error, setError] = useState("");
    const [timeCuts, setTimeCuts] = useState<TimeCut[]>([]);
    const [contextFrames, setContextFrames] = useState<ContextFrame[]>([]);
    const [showDialog, setShowDialog] = useState(false);

    const addCell = () => {
        try {
            const cell = new ContextCell(start, length);
            plane.addCellToRow(rowIndex, cell);
            setError("");
            setPlane(plane); // force update
            setShowDialog(false);
        } catch (err: any) {
            setError(err.message);
        }
    };

    const forceupdate = useReducer(x => x + 1, 0)[1];
    useEffect(() => {
        forceupdate();
    }, [plane]);

    const computeTimeCutsAndFrames = () => {
        setTimeCuts(plane.getTimeCuts());
        setContextFrames(plane.generateContextFrames());
    };

    return (
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
            <h1>Context Plane Visualization</h1>

            {/* Button to show modal dialog */}
            <button onClick={() => setShowDialog(true)}>Add Context Cell</button>

            {showDialog && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Add Context Cell</h2>
                        <label>
                            Row Index:
                            <input
                                type="number"
                                value={rowIndex}
                                onChange={(e) => setRowIndex(Number(e.target.value))}
                            />
                        </label>
                        <br />
                        <label>
                            Start:
                            <input
                                type="number"
                                value={start}
                                onChange={(e) => setStart(Number(e.target.value))}
                            />
                        </label>
                        <br />
                        <label>
                            Length:
                            <input
                                type="number"
                                value={length}
                                onChange={(e) => setLength(Number(e.target.value))}
                            />
                        </label>
                        <br />
                        <button onClick={addCell}>Submit</button>
                        <button onClick={() => setShowDialog(false)}>Cancel</button>
                        {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                </div>
            )}

            <button onClick={computeTimeCutsAndFrames} style={{ marginTop: "20px" }}>
                Compute Time Cuts and Context Frames
            </button>
            <div>
                <h2>Context Plane</h2>
                <RydContextPlaneGrid project={RydProject.createForNewProject("foo")} plane={plane} />
            </div>

            <div style={{ marginTop: "20px" }}>
                <div style={{ display: "inline-flex" }}>
                    {timeCuts.map(({ start, end }, index) => (
                        <div key={index}
                            style={{
                                width: `calc((20px * ${end - start}))`,
                                height: "20px",
                                backgroundColor: "#ddd",
                                color: "#000",
                                fontSize: "10px",
                                outline: "1px solid orange",
                            }}>
                            {start}, {end - start}
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ marginTop: "20px" }}>
                <h2>Context Frames</h2>
                {contextFrames.map((frame, index) => (
                    <div key={index} style={{ marginBottom: "10px" }}>
                        <strong>Frame {index}:</strong>
                        <div style={{ display: "flex", gap: "5px" }}>
                            {frame.cells.map((cell, cellIndex) => (
                                <div
                                    key={cellIndex}
                                    style={{
                                        backgroundColor: "#2196f3",
                                        color: "white",
                                        padding: "5px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    Row {plane.getRows().findIndex((row) =>
                                        row.getCells().includes(cell)
                                    )}
                                    : [{cell.start}, {cell.length}]
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export {
    ContextPlaneOld,
    RydContextLayerPlane
};
